import { render, staticRenderFns } from "./lighting.vue?vue&type=template&id=528baf4e"
import script from "./lighting.vue?vue&type=script&lang=js"
export * from "./lighting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports